import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Section, Eyebrow, H2, Lead, GlassCard, Reveal } from "../components/site/Primitives";
import StatusBadge from "../components/site/StatusBadge";
import { SUBSIDIARIES } from "../data/subsidiaries";

export default function Subsidiaries() {
  return (
    <div>
      <Section className="pt-40">
        <Eyebrow>The 220 Ecosystem</Eyebrow>
        <H2 className="max-w-4xl">Ten planned divisions. One integrated platform.</H2>
        <Lead className="mt-6">
          Each 220 subsidiary is being engineered to stand on its own — and to compound with the others.
          From construction to education to community events, every division is designed to feed the next.
          Divisions are currently in planning, formation, or development as part of the long-term master plan.
        </Lead>
      </Section>

      <Section className="pt-0">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SUBSIDIARIES.map((s, i) => (
            <Reveal key={s.slug} delay={i * 0.03}>
              <Link to={s.href} className="block group h-full" data-testid={`subs-card-${s.slug}`}>
                <GlassCard className="overflow-hidden h-full flex flex-col">
                  <div className="aspect-[16/10] overflow-hidden relative">
                    <img src={s.image} alt={s.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    {s.status && (
                      <div className="absolute top-3 left-3">
                        <StatusBadge kind={s.status} />
                      </div>
                    )}
                  </div>
                  <div className="p-6 flex-1 flex flex-col">
                    <div className="text-xs uppercase tracking-[0.2em] text-gold mb-2">{s.tag}</div>
                    <div className="font-display text-2xl mb-2">{s.name}</div>
                    <p className="text-sm text-white/60 flex-1">{s.short}</p>
                    <div className="mt-5 inline-flex items-center gap-2 text-sm text-gold">
                      Explore <ArrowRight size={14} />
                    </div>
                  </div>
                </GlassCard>
              </Link>
            </Reveal>
          ))}
        </div>
      </Section>
    </div>
  );
}
